import React from 'react';
import PropTypes from 'prop-types';
import { NetworkingConstants } from '../common/Constants';
import NetworkingIconComponent from './NetworkingIconComponent';
import NetworkingService from './NetworkingService';
import { followeeUpdateActions } from '../common/updateFolloweeActions';
import Classes from '../common/Classes';

export default class Networking extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      addedToMyNetwork: props.initialState,
      errors: []
    };
    this.handleClick = this.handleClick.bind(this);
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(newProps) {
    this.setState({
      addedToMyNetwork: newProps.initialState
    });
  }

  handleClick() {
    if (!this.state.addedToMyNetwork) {
      this.addFolloweeToMyNetwork();
      return;
    }
    this.removeFolloweeFromMyNetwork();
  }

  addFolloweeToMyNetwork() {
    const {
      baseApiUrl, userId, digitalPortfolioId, updateFolloweeList
    } = this.props;
    const followeeType = 'Individual';
    NetworkingService.addFolloweeToNetwork(baseApiUrl, digitalPortfolioId, userId, followeeType, this.props.locale)
      .then(() => updateFolloweeList(userId, followeeUpdateActions.ADD))
      .catch((errors) => {
        this.setState({ errors });
      });
  }

  removeFolloweeFromMyNetwork() {
    const {
      baseApiUrl, userId, digitalPortfolioId, updateFolloweeList
    } = this.props;
    NetworkingService.removeFolloweeFromNetwork(baseApiUrl, digitalPortfolioId, userId, this.props.locale)
      .then(() => updateFolloweeList(userId, followeeUpdateActions.REMOVE))
      .catch((errors) => {
        this.setState({ errors });
      });
  }

  render() {
    const isAddedToMyNetwork = this.state.addedToMyNetwork;
    const iconName = NetworkingConstants.networkingIcon;
    const dtmTag = isAddedToMyNetwork ? this.props.dtmData.removeFromMyNetworkIcon
      : this.props.dtmData.addToMyNetworkIcon;
    const altSVG = isAddedToMyNetwork ? this.props.translations.removeFromMyNetwork
      : this.props.translations.addToMyNetwork;
    const id = this.props.participationId;

    const label = isAddedToMyNetwork ? this.props.translations.removeFromMyNetwork
      : this.props.translations.addToMyNetwork;

    return (
      <div data-testid="Networking-component" className={this.props.containerClass}>
        <NetworkingIconComponent
          classname={this.props.classname}
          dtmTag={dtmTag}
          id={id}
          handleClick={this.handleClick}
          isAddedToMyNetwork={isAddedToMyNetwork}
          iconName={iconName}
          altSVG={altSVG}
          label={label}
          isDirectoryView={this.props.isDirectoryView}
        />
        { this.state.errors.length > 0 ? <div key={this.state.errors[0]} className={Classes.textDanger}>{this.state.errors[0].message}</div> : null }
      </div>
    );
  }
}

Networking.propTypes = {
  classname: PropTypes.string,
  containerClass: PropTypes.string,
  baseApiUrl: PropTypes.string,
  initialState: PropTypes.bool,
  participationId: PropTypes.string,
  dtmData: PropTypes.object,
  translations: PropTypes.object,
  userId: PropTypes.string,
  updateFolloweeList: PropTypes.func,
  digitalPortfolioId: PropTypes.string,
  locale: PropTypes.string,
  isDirectoryView: PropTypes.bool
};
